// Same W/L/D palette the staff team-matches page uses (style/Global.js
// + components/table/Matches.js getColorScore). Reused on the player
// matches list, dashboard recent matches, and the EventsVideo match card.
export const RESULT_WIN = '#36E82D';
export const RESULT_LOSS = '#F20A46';
export const RESULT_DRAW = '#E8D02D';

const parseScore = (score) => {
  if (typeof score !== 'string' || !score.includes(':')) return [NaN, NaN];
  const [a, b] = score.split(':');
  return [Number(a), Number(b)];
};

const isPlayerHome = ({ playerIsHome, homeTeam, playerTeams }) => {
  if (typeof playerIsHome === 'boolean') return playerIsHome;
  if (Array.isArray(playerTeams) && playerTeams.length > 0) {
    return playerTeams.filter(Boolean).map((t) => t.name).includes(homeTeam);
  }
  return null;
};

/**
 * Color for a match score based on whether the player won / lost / drew.
 *
 * Accepts either a parsed score string (e.g. "2:1") or explicit numeric
 * homeTeamScore / awayTeamScore. Falls back to DRAW yellow when the
 * player's side can't be determined (no player_is_home flag and no
 * playerTeams to match the home team's name against).
 */
export const resultColorFor = ({
  homeTeam,
  homeTeamScore,
  awayTeamScore,
  score,
  playerIsHome,
  playerTeams,
}) => {
  let home = typeof homeTeamScore === 'number' ? homeTeamScore : NaN;
  let away = typeof awayTeamScore === 'number' ? awayTeamScore : NaN;
  if ((Number.isNaN(home) || Number.isNaN(away)) && score) {
    [home, away] = parseScore(score);
  }
  if (Number.isNaN(home) || Number.isNaN(away)) return RESULT_DRAW;
  if (home === away) return RESULT_DRAW;
  const atHome = isPlayerHome({ playerIsHome, homeTeam, playerTeams });
  if (atHome === null) return RESULT_DRAW;
  const playerWon = atHome ? home > away : away > home;
  return playerWon ? RESULT_WIN : RESULT_LOSS;
};
